<template>
    <DModal
        :show="showModal"
        :is-awaiting-validation="true"
        :title="__('tools.emails.edit_additions')"
        is-big
        is-confirm
        overflow-auto
        @confirm="confirm"
        @close="closeModal"
    >
        <div style="padding: 15px">
            <DFormRow
                :label="__('tools.emails.editor.category')"
                :is-required="true"
                :error="errors.category"
            >
                <DSelect
                    id="addition_category"
                    v-model="form.category"
                    :options="categoryOptions"
                    selection-type="text"
                />
            </DFormRow>
            <DFormRow
                :label="__('tools.emails.editor.sender')"
                :is-required="true"
                :error="errors.sender_type"
            >
                <DSelect
                    id="addition_sender_type"
                    v-model="form.sender_type"
                    :options="senderTypeOptions"
                    selection-type="text"
                    @change="checkCustomType"
                />
            </DFormRow>
            <template
                v-if="form.sender_type === 'Custom'"
            >
                <DFormRow
                    :label="__('tools.emails.editor.sender_address')"
                    :is-required="true"
                    :error="errors.sender_address"
                >
                    <DInput
                        id="addition_sender_address"
                        v-model="form.sender_address"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('tools.emails.editor.sender_name')"
                    :is-required="true"
                    :error="errors.sender_name"
                >
                    <DInput
                        id="addition_sender_name"
                        v-model="form.sender_name"
                    />
                </DFormRow>
            </template>
        </div>
    </DModal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    addition: {
        type: Object,
        default: () => ({})
    },
    showModal: {
        type: Boolean,
        default: false
    },
    categories: {
        type: Array,
        default: () => []
    },
    senderTypes: {
        type: Array,
        default: () => []
    }
})
const emit = defineEmits(['modalClosed'])
const form = useForm({
    name: props.addition.name,
    category: props.addition.category,
    sender_type: props.addition.sender_type,
    sender_address: props.addition.sender_address,
    sender_name: props.addition.sender_name
})
const oldSenderAddress = ref(null)
const oldSenderName = ref(props.addition.sender_name)
const errors = ref({})

const categoryOptions = computed(() => {
    return props.categories.map((cat) => ({
        label: cat,
        value: cat
    }))
})
const senderTypeOptions = computed(() => {
    return props.senderTypes.map((senderType) => ({
        label: senderType,
        value: senderType
    }))
})

const confirm = () => {
    form.post(route('tools.emails.editor.update_addition', {}, true), {
        onSuccess: () => {
            emit('modalClosed')
        },
        onError: (error) => {
            errors.value = error
        }
    })
}
const closeModal = () => {
    emit('modalClosed')
}
const checkCustomType = () => {
    if (form.sender_type === 'Custom') {
        if (oldSenderAddress.value !== null) {
            form.sender_address = oldSenderAddress.value
            oldSenderAddress.value = null
        }
        if (oldSenderName.value !== null) {
            form.sender_name = oldSenderName.value
            oldSenderName.value = null
        }

        return
    }

    if (form.sender_address !== null) {
        oldSenderAddress.value = form.sender_address
        form.sender_address = null
    }
    if (form.sender_name !== null) {
        oldSenderName.value = form.sender_name
        form.sender_name = null
    }
}
</script>
